// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"428":"b0d58a5c","894":"07ade2c3"}[chunkId] + ".chunk.css";
};